var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-none d-lg-block d-xl-block mb-2 ont-size-14px"},[_vm._v(" Selezione del posto per "),_c('span',{staticClass:"text-primary semibold"},[_vm._v(_vm._s(_vm.passengerName))]),(_vm.isHoldingInfant)?_c('span',[_vm._v(" con "),_c('span',{staticClass:"text-primary semibold"},[_vm._v("neonato")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }